import TableConfigV3, {
    ColumnTypes,
} from "../../components/TableV3/TableV3Config";

const PendingApprovalTableConfig: TableConfigV3 = {
    id: "uidNew",
    checkBox: true,
    checkBoxActions: [
        {
            text: "Download",
            func: "download",
            color: "primary",
        },
        {
            text: "Approve",
            func: "hr_approve",
            color: "info",
        },
        {
            text: "Reject",
            func: "hr_reject",
            color: "warning",
        },
    ],
    columns: [
        {
            title: "Actions",
            dataIndex: "actions",
            type: ColumnTypes.Action,
            width: "5em",
            actions: [
                {
                    func: "hrDownload",
                    display: {
                        text: "'Download'",
                        condition: "#idUploaded",
                        icon: "download",
                    },
                },
            ],
        },
        {
            title: "Name",
            dataIndex: "name",
            type: ColumnTypes.String,
            sorter: true,
            width: "12em",
        },
        {
            title: "ID",
            dataIndex: "employeeId",
            type: ColumnTypes.Number,
            width: "8em",
        },
        {
            title: "D.O.B",
            dataIndex: "dobStr",
            width: "80px",
        },
        {
            title: "Relationship",
            dataIndex: "relationShip",
            width: "7em",
        },
        {
            title: "Gender",
            dataIndex: "gender",
            width: "4em",
        },
        {
            title: "Premium amount",
            dataIndex: "ghiAmount",
            type: ColumnTypes.Money,
            width: "6em",
        },
        {
            title: "Request Date",
            dataIndex: "requestDateStr",
            sorter: true,
            width: "8em",
        },
        {
            title: "Start Date",
            dataIndex: "dateOfJoiningStr",
            sorter: true,
            width: "8em",
        },
    ],
};

export default PendingApprovalTableConfig;
